
export const REDESIGN_REQUEST_STATUSES = {
  PENDING: 'REDESIGN_REQUEST_PENDING'
};
